import './separator.scss';

const Separator = () => {
  return <hr className="separator-component"></hr>;
};

export default Separator;
